import React from "react";
import PropTypes from "prop-types";
import { outcomePropType } from "../../lib/dataShapes";
import { Qualities } from "../../lib/utils";
import OutcomeName from "./OutcomeName";
import TextContent from "../common/TextContent";
import styles from "../../styles/outcomeTable.module.scss";

const NarrativeOutcomeTableRow = ({ outcome }) => {
  return (
    <div className={styles.outcomeTableRow}>
      <div className={styles.narrativeOutcomeRow}>
        <div className={styles.outcomeNameCell}>
          <OutcomeName outcome={outcome} />
        </div>
        <div className={styles.narrativeOutcomeContent}>
          <div className={styles.narrativeOutcomeText}>
            <TextContent content={outcome.narrativeDesc} />
          </div>
        </div>
        <div
          className={styles.narrativeOutcomeCertainty}
          dangerouslySetInnerHTML={{
            __html:
              outcome.quality && `${Qualities[outcome.quality]}<br>certainty`
          }}
        />
      </div>
    </div>
  );
};

NarrativeOutcomeTableRow.propTypes = {
  outcome: PropTypes.shape(outcomePropType).isRequired
};

export default NarrativeOutcomeTableRow;
